define([
	"./_AutoSize",
	"./PluginFactory"
], function(_AutoSize,PluginFactory) {

	return PluginFactory.declare(_AutoSize, {
		"class": "csi-button-toggle",
		cssValue: "FIXED_HEIGHT",
		iconClass: "csiActionIcon svgIconAutosizeFixedHeight",
		pluginName: "fixedHeight",
		title: "CanvasAutosizeFixedHeight"
	});
});
